import { render, staticRenderFns } from "./SensorPortRadio.vue?vue&type=template&id=397d3131&scoped=true&"
import script from "./SensorPortRadio.vue?vue&type=script&lang=js&"
export * from "./SensorPortRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d3131",
  null
  
)

export default component.exports